import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Space } from 'antd';
import LoyaltyPoinSettinService from "services/loyalty_point";
import ImagePicker from "components/pickers/image/ImagePicker"
import { useForm, useWatch } from "antd/es/form/Form";
import { useApp } from 'contexts/app';
import InputNumber from 'components/input-number';
import { formatCurrency } from "utils/number"
const service = new LoyaltyPoinSettinService();

const LoyaltySetting = () => {
    const [form] = useForm();
    const { showLoading, showNotify } = useApp();
    const [oldSetting, setOldSetting] = useState({})
    const amountValue = Form.useWatch('amount', form);
    const maxPerOrderValue = Form.useWatch('max_per_order', form);
    useEffect(() => {
        loadData();
    }, []);



    const loadData = async () => {
        var setting = await service.getLoyaltyPoint();
        form.setFieldsValue(setting);
        setOldSetting(setting);
    }

    const onFinish = async values => {
        // console.log('Success:', values);
        showLoading(true);
        await service.saveLoyaltyPoint(values)
        await loadData();
        showLoading(false);
        showNotify("Đã cập nhật")
    };
    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };
    return (


        <Form
            form={form}
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ maxWidth: 600 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
        >

            <Form.Item
                label="Bật tích xu"
                name="on"
                rules={[{ required: true }]}
                valuePropName='checked'
                tooltip="Khi bật, khách hàng sẽ được tích xu sau mỗi đơn hàng hoàn tất"
            >
                <Checkbox>Cho phép khách hàng tích xu khi mua hàng</Checkbox>
            </Form.Item>
            <Form.Item
                label="Mức quy đổi"
                name="amount"
                rules={[{ required: true, message: 'Vui lòng nhập mức quy đổi' }]}
                tooltip="Số tiền khách cần chi tiêu để nhận được 1 xu"
            >
                <InputNumber suffix={"đồng = 1 xu"} style={{ width: 300 }} />
            </Form.Item>
            <Form.Item
                label="Giới hạn xu/đơn"
                name="max_per_order"
                tooltip="Số xu tối đa khách có thể áp dụng trong một đơn hàng. Nhập 0 để không giới hạn."
            >
                <InputNumber min={0} suffix={"xu / đơn (0 = không giới hạn)"} style={{ width: 300 }} />
            </Form.Item>
            <Form.Item label="Ví dụ">
                <div>
                    {(amountValue && amountValue > 0) &&
                        <div>• Hoá đơn 1.000.000 đồng: khách được tích <b>{formatCurrency(Math.round(1000000 / amountValue))} xu</b></div>
                    }
                    <div>• Khi sử dụng xu: <b>1 xu = 1 đồng</b> để giảm trừ trực tiếp vào đơn hàng</div>
                    {maxPerOrderValue > 0 ? (
                        <div>• Mỗi đơn hàng chỉ được dùng tối đa <b>{formatCurrency(maxPerOrderValue)} xu</b> (tương đương {formatCurrency(maxPerOrderValue)} đồng)</div>
                    ) : (
                        <div>• Hiện <b>không giới hạn</b> số xu dùng trong một đơn hàng</div>
                    )}
                </div>
            </Form.Item>

            <Form.Item label={null}>
                <Button type="primary" htmlType="submit">
                    Cập nhật
                </Button>
            </Form.Item>
        </Form>
    )
}
export default LoyaltySetting;